import styled from 'styled-components';

export const FlexWrapper = styled.div`
  text-align: center;
  font-size: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  color: ${({ theme }) => theme.text.primary};
`;
